import ApplePayProcess from 'app/components/OrderPayment/ApplePay/ApplePayProcess';
import React from 'react';

const ApplePayPayment = () => {
  return <ApplePayProcess />;
};

export default ApplePayPayment;
